/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */
import { IWidgetVotingReducer } from '../types/widgetVotingTypes';

export const widgetVotingInitialState: IWidgetVotingReducer = {
    data: {
        anonymous: true,
        daysSpan: 0,
        url: '',
        userId: 0,
    },
    error: '',
};

